import {ErrorHandler, NgModule} from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch,
} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
//Modules
import {IrbClientsModule} from '@irb/irb-clients/irb-clients.module';
import {IrbCommonModule} from '@irb-common/irb-common.module';
import {IrbSettingsModule} from '@irb/irb-settings/irb-settings.module';
import {IrbEditorsModule} from '@irb/irb-editors/irb-editors.module';
import {IrbDialogsModule} from '@irb/irb-dialogs/irb-dialogs.module';
//UI
import {LicenseManager} from 'ag-grid-enterprise';
import {AppComponent} from './app.component';
import {ROUTES} from './app.routes';
import {TOKENS} from './app.tokens';
import {AppService} from './app.service';
import {AuthService} from '@irb-common/services/auth.service';

import { IrbCreatePortfolioModule } from '@irb/irb-create-portfolio/irb-create-portfolio.module';

import { IrbDashboardModule } from '@irb/irb-dashboard/irb-dashboard.module';
import { httpInterceptorProviders } from '@irb-common/http-interceptors/index';
import { IrbAuthenticationModule } from './irb-authentication/irb-authentication.module';
import { IrbInitialSetupModule } from './irb-initial-setup/irb-initial-setup.module';
import {IrbAuthenticationGuard} from '@irb/irb-authentication/irb-authentication.guard';
import {MainMenuModule} from '@irb-common/modules/main-menu/main-menu.module';
import {IrbCreateRebalanceModule} from '@irb/irb-create-rebalance/irb-create-rebalance.module';

import {GlobalErrorHandler} from '@irb-common/services/global-error-handler';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);
import { AllEnterpriseModule } from 'ag-grid-enterprise';
ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-116098}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{PHOENIX_AZ_DC_7}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{iRebal_Enterprise}_only_for_{37}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{iRebal_Enterprise}_need_to_be_licensed___{iRebal_Enterprise}_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_July_2027}____[v3]_[01]_MTgxNjIxMDgwMDAwMA==978c15a305b99be757b7e93d5b102ba4');


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {onSameUrlNavigation: 'reload'} ),
    ReactiveFormsModule,
    MainMenuModule,
    IrbEditorsModule,
    IrbDialogsModule,
    IrbCommonModule,
    IrbSettingsModule,
    IrbCreatePortfolioModule,
    IrbDashboardModule, 
    IrbAuthenticationModule,
    IrbInitialSetupModule,
    IrbCreateRebalanceModule,
      IrbClientsModule,
      FormsModule
  ],
  declarations: [
    AppComponent
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    ...TOKENS, AppService, AuthService, httpInterceptorProviders, IrbAuthenticationGuard,
    provideHttpClient(
        withFetch(),
        withInterceptorsFromDi()
    ),
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: 'none'
        }
      }
    })
  ]
})
export class AppModule {}
